import { createEvent, createStore } from 'effector';
import { Org } from '@nx-frontend/shared/types';

export const initialCurrentOrganizationState: Org = {
  globalId: '',
  userId: 0,
  createdAt: 0,
  updatedAt: 0,
  title: '',
  sub: '',
  maxMembers: 0,
  suspended: false,
  suspendedAt: 0,
  suspendedReason: '',
  domain: '',
  domainShorter: false,
  description: undefined,
  peopleToCollaborate: undefined,
  pricingModel: undefined,
  type: '',
  smallLogoStoredFileUUID: undefined,
  bigLogoStoredFileUUID: undefined,
  isOtherDescription: false,
  authFormText: '',
  authFormPrivacyLinkEnabled: false,
  authAllowRegistration: false,
  privacyLinkText: '',
  privacyLinkUrl: '',
  orgType: '',
  isShareAdEnabled: false,
};

export const $currentOrganization = createStore(initialCurrentOrganizationState);

export const setCurrentOrganizationEvent = createEvent<Org>();

$currentOrganization.on(setCurrentOrganizationEvent, (_, newCurrentOrganization) => newCurrentOrganization);
